import type { ConceptDef } from '../types';

export const intraverbalFeature: ConceptDef = {
  kind: 'tileMatch',
  id: 'intraverbal-feature',
  label: 'Intraverbal Feature',
  category: 'Intraverbal',
  description: 'Hear a feature question; tap an item that has it.',
  config: {
    promptMode: 'AUDIO',
    tileCount: 4,
    items: [
      { say: 'What has a tail?', answer: '🐶 dog' },
      { say: 'What has wheels?', answer: '🚗 car' },
      { say: 'What has stripes?', answer: '🦓 zebra' },
      { say: 'What has feathers?', answer: '🐦 bird' },
      { say: 'What has wings?', answer: '✈ airplane' },
      { say: 'What has leaves?', answer: '🌳 tree' },
    ],
  },
};
